import axios from 'axios';
import {BASE_URL} from '../constants/GlobalConstants'

class WatchListService {

    getWatchList(){
        return axios.get(BASE_URL + "/watchlists")
    }

    postWatchList(productId){
        return axios.post(BASE_URL + "/watchlists/" + productId);
    }

    deleteWatchListItem(watchListId){
        return axios.delete(BASE_URL + "/watchlists/" + watchListId);
    }

}

export default new WatchListService();